// extracted by mini-css-extract-plugin
export default {"container":"Jp-z","brandName":"Kp-z","productName":"Lp-z","productNamePdpEnhancements":"Mp-z","breakLongProductName":"Np-z"};